import { ConfigTabNav, tabsFromNavItems } from '@/components/layout/ConfigTabNav';
import { processesNavItem } from '@/layout/nav/navigationConfig';

const tabs = tabsFromNavItems(processesNavItem.items ?? []);

export function ProcessTabsNav() {
  return <ConfigTabNav tabs={tabs} />;
}
